import { type MediaRequest, TranscriptRequest } from "shared/resources";
import { type Stream } from "shared/types";
import { type Mention, MentionType } from "shared/types/mentions";

import {
  type OrganisationReportBaseRequestItem,
  type OrganisationReportExternalItem,
  type OrganisationReportFolderItem,
  type OrganisationReportQuery,
  type OrganisationReportReportRequestItemType,
} from ".";

export function isOrganisationReportMention(
  item: OrganisationReportFolderItem
): item is Mention {
  if (!("type" in item)) {
    return false;
  }

  const type = item.type as
    | MentionType
    | OrganisationReportReportRequestItemType;

  if (
    type === "customer_article" ||
    type === "external_item" ||
    type === "radio_media_request" ||
    type === "tv_media_request" ||
    type === "transcript_request"
  ) {
    return false;
  }

  return Boolean(MentionType[type as MentionType]);
}

export function isOrganisationReportQuery(
  query: Stream | OrganisationReportQuery
): query is OrganisationReportQuery {
  return "isMediaItems" in query || "isTranscriptRequest" in query;
}

export function isOrganisationReportExternalItem(
  item: OrganisationReportFolderItem
): item is OrganisationReportExternalItem {
  return "folder" in item && "file_name" in item;
}

export function isTranscriptRequest(
  item: MediaRequest | TranscriptRequest
): item is TranscriptRequest {
  return item instanceof TranscriptRequest;
}

export function isOrganisationReportBaseItem(
  item: OrganisationReportFolderItem
): item is OrganisationReportBaseRequestItem {
  return (
    "type" in item &&
    ["radio_media_request", "tv_media_request", "transcript_request"].includes(
      item.type as OrganisationReportReportRequestItemType
    )
  );
}
